import { useEffect, useState } from "react"
import withLoader from "../../components/layouts/WithLoader"
import WarehouseService from "../../services/WarehouseService"

import StatsProductWarehouseBrand from "./table/StatsProductWarehouseBrand";
import StatsProductWarehouseCategory from "./table/StatsProductWarehouseCategory";
import StatsProductWarehouseSousFamille from "./table/StatsProductWarehouseSousFamille";
import StatsProductWarehouseFamille from "./table/StatsProductWarehouseFamille";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";





const WarehouseStats = ({ startLoading, stopLoading }) => {

  const [brandQuantities, setBrandQuantities] = useState([])
  const [categoryQuantities, setCategoryQuantities] = useState([])
  const [sousFamilleQuantities, setSousFamilleQuantities] = useState([])
  const [familleQuantities, setFamilleQuantities] = useState([])
  const [ca, setCa] = useState(0);
  const [achat, setAchat] = useState(0);
  useEffect(() => {
    startLoading();
    WarehouseService.getWarehouseSummary(sessionStorage.getItem("idWarehouse")).then((response) => {
      setBrandQuantities(response.data["brand-quantities"]);
      setCategoryQuantities(response.data["category-quantities"]);
      setSousFamilleQuantities(response.data["subFamily-quantities"]);
      setFamilleQuantities(response.data["family-quantities"]);

    }).catch((error) => {
      console.log("error", error)

    }).finally(() => {
      stopLoading();
    })

    startLoading()
    WarehouseService.getAllAchatAndCAWarehouseById(
      sessionStorage.getItem("idWarehouse")
    )
      .then((response) => {
        // if (response.data["success"]) {
        //   console.log("response", response.data["success"]);
        //   setNameWarehouse(response.data["warehouse"])
        //   setWarehouseManagers(response.data["managers"]);
        //   setAdressWarehouse(response.data["adress"])
        //   setDeviseWarehouse(response.data["devise"])
        // }

        if (response.data["ca"]) {
          setCa(response.data["ca"])
        }

        if (response.data["achat"]) {
          setAchat(response.data["achat"])
        }
      })
      .catch((e) => {
        console.log("error", e);
      }).finally(() => {
        stopLoading()
      })


  }, [])


  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <br />
      <div className="content ">
        <div className="container-fluid">
          {sessionStorage.getItem("typeDocument") === "Warehouse" && (
            <><div className="row">
              <div className="col-md-12 col-sm-6 col-12">
                <div className="info-box bg-gray ">
                  <span className="info-box-icon">
                    <i class="fas fa-map-marker-alt mr-1"></i>{" "}
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Dépôt</span>
                    <span className="info-box-number">

                      {sessionStorage.getItem("warehouseRef")}- {sessionStorage.getItem("warehouseName")}{" "}
                    </span>
                    <div className="progress">
                      <div className="progress-bar" style={{ width: "100%" }} />
                    </div>

                    <span className="progress-description">
                      {/* {warehouse.address} */}
                    </span>
                  </div>
                </div>
              </div>




            </div>
            </>
          )}
          <div className="row">
            <div className="col-md-6 col-sm-6 col-12">
              <div className="info-box bg-gray ">
                <span className="info-box-icon">
                  <i class="fas fa-money-bill-trend-up"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Chiffre d'affaire previsionnel (par pièce)</span>
                  <span className="info-box-number">
                    {ca}
                  </span>
                  {/* <div className="progress">
                      <div className="progress-bar" style={{ width: "70%" }} />
                    </div>

                    <span className="progress-description">
                      
                    </span> */}
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-6 col-12">
              <div className="info-box bg-gray-dark ">
                <span className="info-box-icon">
                  <i class="fas fa-money-bill-transfer"></i>                  </span>
                <div className="info-box-content">
                  <span className="info-box-text">Valeur de stock</span>
                  <span className="info-box-number">
                    {achat}
                  </span>
                  {/* <div className="progress">
                      <div className="progress-bar" style={{ width: "70%" }} />
                    </div>

                    <span className="progress-description">
                      
                    </span> */}
                </div>
              </div>
            </div>
          </div>



          <div className="row">
            <div className="col-sm-6">
              <StatsProductWarehouseSousFamille data={sousFamilleQuantities} />
            </div>
            <div className="col-sm-6">
              <StatsProductWarehouseFamille data={familleQuantities} />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <StatsProductWarehouseBrand data={brandQuantities} />
            </div>
            <div className="col-sm-6">
              <StatsProductWarehouseCategory data={categoryQuantities} />
            </div>
          </div>
        </div>
      </div>
    </div>

  )




}
export default withLoader(WarehouseStats)